"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomCheckoutInstance = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var utils_1 = (0, tslib_1.__importDefault)(require("../components/CreditCard/utils"));
/** Load bambora js script for payment form to work locally and sets Custom Checkout instance when it is mounted/ready */
function useCustomCheckoutInstance(bamboraURL, skipMountingScript) {
    var ready = (0, utils_1.default)(bamboraURL, skipMountingScript)[0];
    var _a = (0, react_1.useState)(null), instance = _a[0], setInstance = _a[1];
    (0, react_1.useEffect)(function () {
        if (ready) {
            setInstance(window.customcheckout());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ready]);
    return instance;
}
exports.useCustomCheckoutInstance = useCustomCheckoutInstance;
//# sourceMappingURL=useCustomCheckoutInstance.js.map